import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { v2_parcelSearchResult } from '@lanterds/types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import './SidebarContent.scss';
import { useFmtpNavigate } from 'src/hooks/useFmtpNavigate';

interface SidebarContentProps {
    parcelInfo: v2_parcelSearchResult;
}

export default function SidebarContent({ parcelInfo }: SidebarContentProps) {
    const fmtpNavigate = useFmtpNavigate();

    const location = useLocation();

    const showBackButton = location?.state && location.state['from'] ? !!location.state['from'] : null;

    const { endPointInfo } = parcelInfo || {};

    const formattedAddress = (
        <>
            {endPointInfo?.endPointName && endPointInfo?.endPointName !== 'null' && endPointInfo?.endPointName}
            {endPointInfo?.endPointName && endPointInfo?.endPointName !== 'null' && <br />}
            {endPointInfo?.endPointStreet && endPointInfo?.endPointStreet !== 'null' && endPointInfo?.endPointStreet}
            {endPointInfo?.endPointStreet && endPointInfo?.endPointStreet !== 'null' && <br />}
            {endPointInfo?.endPointCity && endPointInfo?.endPointCity !== 'null' && endPointInfo?.endPointCity + ', '}
            {endPointInfo?.endPointState && endPointInfo?.endPointState !== 'null' && endPointInfo?.endPointState + ' '}
            {endPointInfo?.endPointZip && endPointInfo?.endPointZip !== 'null' && endPointInfo?.endPointZip}
        </>
    );

    return (
        <>
            <div className="sidebar-content">
                <div className="action-container">
                    {showBackButton && (
                        <Link to={'/'} state={{ from: 'parcelCode', previousResults: location.state['previousResults'] }}>
                            <ArrowBackIcon /> Back
                        </Link>
                    )}
                </div>
                {/* TODO: Add logoUrl when BE updated to provide it */}
                {/* {logoUrl && (
                    <div className="sidebar-content__logo-container">
                        <img alt={parcelInfo?.customer?.customerName} className="sidebar-content__logo-img" src={logoUrl} />
                    </div>
                )} */}

                <div className="sidebar-content__summary-container">
                    <table className="summary-table">
                        <tbody>
                            <tr>
                                <td className="summary-table__header">Parcel Code</td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value">{parcelInfo?.parcelCode}</td>
                            </tr>
                            <tr>
                                <td className="summary-table__header">End Point Number</td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value">{endPointInfo?.endPointNumber}</td>
                            </tr>
                            <tr>
                                <td className="summary-table__header" colSpan={2}>
                                    End Point Address
                                </td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value" colSpan={2}>
                                    {formattedAddress}
                                </td>
                            </tr>
                            <tr>
                                <td className="summary-table__header">Weight</td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value">{parcelInfo?.weight}</td>
                            </tr>
                            <tr>
                                <td className="summary-table__header">Manifest</td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value">{parcelInfo?.manifest}</td>
                            </tr>
                            <tr>
                                <td className="summary-table__header">Part Number</td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value">{parcelInfo?.partNumber}</td>
                            </tr>
                            <tr>
                                <td className="summary-table__header">Origin</td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value">{parcelInfo?.origin}</td>
                            </tr>
                            <tr>
                                <td className="summary-table__header">Freight Type</td>
                            </tr>
                            <tr className="summary-table__value__row">
                                <td className="summary-table__value">{parcelInfo?.freightType}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
